import styles from './styles.module.scss';

import classNames from 'classnames';
import { Icons } from 'pages/Workshop/Icons';

import { Filter } from '../../Filter';
import { ShowingsFilter } from '../QuickFilters';
import { getShowingArchiveIdSelector } from 'store/selectors/showingAggregate';
import { useSelector } from 'react-redux';

export const ShowingActionButtons = (props) => {
  const { onSearchClick } = props;

  const { showingId } = useSelector(getShowingArchiveIdSelector);

  return (
    <div className={styles.actionButtonsPanel}>
      <ShowingsFilter />

      <div className={classNames(styles.searchButton)} onClick={onSearchClick}>
        <Icons className={styles.btnIcon} variant={Icons.SEARCH} color="#515151" />
      </div>

      {!showingId && <Filter />}
    </div>
  );
};
